import { render, staticRenderFns } from "./FEMandateList.vue?vue&type=template&id=3b9f66a4&"
import script from "./FEMandateList.vue?vue&type=script&lang=ts&"
export * from "./FEMandateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports